import React, { useState } from 'react';
import Error from './Error';
import PropTypes from 'prop-types';

const Form = ({saveSearch}) => {

    const [term, saveTerm] = useState('');
    const [error, hasError] = useState(false);

    const searchImage = (e) => {
        e.preventDefault();

        //validar
        if (term.trim() === '') {
            hasError(true);
            return;
        }
        hasError(false);

        //Enviar
        saveSearch(term);
    }

    return (
        <form
            onSubmit={searchImage}
        >
            <div className="row">
                <div className="form-group col-md-8">
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Busca una imagen, ejemplo: futbol o café"
                        onChange={e => saveTerm(e.target.value)}
                    />
                </div>
                <div className="form-group col-md-4">
                    <input
                        type="submit"
                        className="btn btn-lg btn-danger btn-block"
                        value="Buscar"
                    />
                </div>
            </div>

            {error ? <Error message="Agregar un término de búsqueda" /> : null}

        </form>
    );
}

Form.proptTypes = {
    saveSearch: PropTypes.func.isRequired
}

export default Form;